import I18n from 'i18n-js';
import React, { Component } from 'react'
import mela_logo from '../images/mela_rgb.png';

export default class Header extends Component {
    constructor(props)
    {
        super(props);
    };

    render() {
        return (
            <div className={"site-header " + (this.props.frontpage ? "container content-wrapper-wide" : "container container-small")}>
                <div className="d-flex justify-content-between">
                    <a href={I18n.t("header.href_mela")} className='d-flex flex-shrink-0'>
                        <img src={mela_logo} alt={I18n.t("header.logo_alt")} id="header_logo"></img>
                    </a>
                    <span>
                        <a className='mela-blue' style={{cursor: "pointer", textDecoration: "none"}} onClick={() => {localStorage.setItem("locale", "fi"); window.location.reload(false);}}>Suomeksi</a>
                        {" | "}
                        <a className='mela-blue' style={{cursor: "pointer", textDecoration: "none"}} onClick={() => {localStorage.setItem("locale", "sv");window.location.reload(false);}}> På svenska</a>
                    </span>
                </div>
            </div>
        )
    }
}
